import styles from "@/styles/productDetail.module.scss"
import { useState, useEffect } from 'react'
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import GoodsSmallComponent from '@/components/global/GoodsSmallComponent'
import BreadCrum from '@/components/global/BreadCrum'
import PromotionBox from '@/components/productDetail/PromotionBox'
import ProductInfo from '@/components/productDetail/ProductInfo'
import ShopInfo from "@/components/ShopInfo"
import PaymentNotice from '@/components/productDetail/PaymentNotice'
import SwiperSmall from '@/components/global/SwiperSmall'
import { SwiperSlide } from 'swiper/react'
import ProductDetail from "@/components/productDetail/ProductDetail"
import ProductReviews from "@/components/productDetail/ProductReviews/index"
import AddPurchase from "@/components/productDetail/AddPurchase"
import productApi from '@/service/modules/productApi'
import DetailRecommend from "@/components/productDetail/DetailRecommend"
import InterestedProducts from "@/components/productDetail/InterestedProducts"
import HotSearch from "@/components/productDetail/HotSearch"
import NewArrivals from "@/components/productDetail/NewArrivals"
import MidBanner from "@/components/productDetail/MidBanner"
import Head from "next/head"
import { getCookie, setCookie } from '@/utils/cookie'
import { abTestCalculate } from "@/utils/ABtest"
import getConfig from 'next/config'
import { useRouter } from 'next/router'
import { setGtmDataLayer } from "@/utils/gtmDataLayer"
import GoogleADSense from "@/components/GoogleADSense"
import dayjs from 'dayjs'
import Combination from "@/components/productDetail/Combination"
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain
interface PictureItem {
  thumbnailUrl: string;
  imageHDUrl: string;
  imageORUrl: string;
  fileNameUrl: string;
  isDefault: number;
}

interface RelatedProductItem {
  name: string;
  productID: string;
  url: string;
  newThumbnail?: string;
  filename: string;
  price: number;
  normalPrice: number;
}

interface BreadcrumbItem {
  name: string;
  url: string;
  current: boolean;
}

interface ReviewData {
  avgRank: number;
  total: number;
  summary: any;
}

interface paymentMethodItem {
  paymentName: string;
  paymentIcon: string;
}

interface variantProductsItem {
  productID: number;
  name: string;
  thumbnail: string;
  defaultMember: number;
  url: string;
  options: { optionID: number; variantID: number }[]; // 内联Option对象数组
}

interface ProductDetailData {
  name: string;
  productID: number;
  categoryID: number;
  url: string;
  enabled: number;
  discontinued: number;
  price: number;
  promotionPrice: number;
  normalPrice: number;
  promotionTypeID: string | number;
  inStock: number;
  courierID: number;
  freeShipping: number;
  preSales: number;
  preSalesDate: string;
  isEmailOnly: boolean;
  isNew: number | undefined;
  isGroup: number;
  onSale: number;
  reduced: number;
  pictures: PictureItem[];
  firstMagnifierImage?: string;
  newThumbnail: string;
  filename: string;
  promotion: {
    productID: number;
    promotionType: number;
    promotionPrice: number;
    normalPrice: number;
    endDate: string;
    status: number;
    notified: number;
    pointRate: string;
    discountPercent: string;
    ebaySync: number;
  };
  emailOnlyFinished: number;
  breadCrumb: BreadcrumbItem[];
  relatedProducts: RelatedProductItem[];
  review: ReviewData | null | undefined;
  paymentMethod: paymentMethodItem[];
  currentTime: string;
  warehouseID: number;
  crazyDeal?: {
    hoursLeft: number;
    minutesLeft: number;
    secondsLeft: number;
  } | undefined;
  variants: {
    options: {
      color?: any;
      size?: any
    };
    products: variantProductsItem[];
  };
  seo: {
    title: string;
    description: string;
    keywords: string;
  }
}

interface ProductPageProps {
  productDetail: ProductDetailData | null,
}

// 获取产品详情
async function getProductDetail(productId: string | number) {
  try {
    let productData = await productApi.getProductDetail(productId)

    return {
      ...productData
    }
  } catch (error) {
    console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `  Product: ${productId}  Data acquisition failed: `, JSON.stringify(error))
  }
}

// 在服务器端渲染时调用接口，并返回 props 给页面组件
export async function getServerSideProps(context: any) {
  // 获取 URL 中的 product 参数
  const { product } = context.query

  // 获取字符串中的productId
  const lastDashIndex = product.lastIndexOf('-')
  const productId = product.substring(lastDashIndex + 1)

  // 获取URL上的参数str
  var url = context.resolvedUrl || ''
  const urlParams = url.split('?')[1] ? `?${url.split('?')[1]}` : ''

  const detail = await getProductDetail(productId)

  if (detail) {
    // replaceUrl要和当前商品Url做个比对，不同就重写到replaceUrl
    if (
      detail.data?.link
      && detail.data.link?.replaceUrl
      && detail.data.link.replaceUrl != detail.data.product.url
    ) {
      return {
        redirect: {
          destination: detail.data.link.replaceUrl + urlParams,
          permanent: false,
        }
      }
    }

    // 如果有返回数据，判断产品名称是否匹配
    if (detail.data.product.url === `/${product}.html`) {

      try {
        // 请求releaseProduct和reviews数据
        let releaseProductData = await productApi.getProductScreen(productId)
        if (releaseProductData.data) {
          detail.data.product = {
            ...detail.data.product,
            ...releaseProductData.data,
            breadCrumb: detail.data.breadCrumb,
            paymentMethod: detail.data.paymentMethod
          }
        } else {
          // 查不出来也给个默认值
          detail.data.product = {
            ...detail.data.product,
            ...{
              relatedProducts: [],
              review: {
                avgRank: 5,
                total: 0,
                summery: {
                  rating1: 0,
                  rating2: 0,
                  rating3: 0,
                  rating4: 0,
                  rating5: 0
                }
              }
            },
            breadCrumb: detail.data.breadCrumb,
            paymentMethod: detail.data.paymentMethod
          }
        }
      } catch (error) {
        console.log('Next.js Error :', dayjs().format('YY-MM-DD HH:mm:ss'), `  Product: ${productId}   releaseProduct and reviews Data acquisition failed:  `, JSON.stringify(error))

        // 抛错也给个默认值
        detail.data.product = {
          ...detail.data.product,
          ...{
            relatedProducts: [],
            review: {
              avgRank: 5,
              total: 0,
              summary: {
                rating1: 0,
                rating2: 0,
                rating3: 0,
                rating4: 0,
                rating5: 0
              }
            }
          }
        }
      }

      // 处理商品缩略图
      if (
        detail.data.product
        && detail.data.product.pictures
      ) {
        let pictures = JSON.parse(JSON.stringify(detail.data.product.pictures))
        let needInject = false
        let target: any = []

        let firstMagnifierImage = ''
        pictures.forEach((item: any, index: number) => {
          if (item.isDefault === 1 && index >= 12) {
            needInject = true
            target = item
          }

          if (item.isDefault === 1) {
            firstMagnifierImage = item.imageHDUrl || item.imageORUrl || item.fileNameUrl
            detail.data.product.firstMagnifierImage = firstMagnifierImage
          }
        })
        if (!firstMagnifierImage) {
          let target = pictures[0]
          firstMagnifierImage = target.imageHDUrl || target.imageORUrl || target.fileNameUrl
        }
        if (needInject) {
          pictures.unshift(target)
          detail.data.product.pictures = pictures
        }
      }
      return {
        props: {
          productDetail: detail.data.product
        }
      }
    } else {
      // 如果不匹配，拼接正确的 URL，并用 redirect 方法跳转
      return {
        redirect: {
          destination: detail.data.product.url + urlParams,
          permanent: false,
        }
      }
    }
  } else {
    // 如果没有返回数据，返回一个 notFound 的标志，让 Next.js 渲染一个内置的 404 页面
    return {
      notFound: true,
    }
  }
}

export default function ProductPage({ productDetail }: ProductPageProps) {

  // console.log(productDetail, '===  productDetail');

  const [updateProductDetail, setUpdateProductDetail] = useState<ProductDetailData | null>(productDetail)

  const [slidesPerView, setSlidesPerView] = useState(6)
  const [isBeginning, setIsBeginning] = useState(true)
  const [isEnd, setIsEnd] = useState(false)

  function onSlideChange(isBeginning: boolean, isEnd: boolean) {
    setIsBeginning(isBeginning)
    setIsEnd(isEnd)
  }

  useEffect(() => {
    // 监听页面resize事件, 根据屏幕大小改变轮播图展示个数
    function handleResize() {
      if (window.innerWidth >= 1158) {
        setSlidesPerView(6)
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1158) {
        setSlidesPerView(5)
      } else if (window.innerWidth >= 900 && window.innerWidth < 1024) {
        setSlidesPerView(4)
      } else {
        setSlidesPerView(3)
      }
    }

    handleResize()

    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    };
  }, [])

  const [warrantyHtml, setWarrantyHtml] = useState("")
  // 切换商品数量
  const [quantityNum, setQuantityNum] = useState(1)
  const handleQuantityChange = (value: number) => {
    console.log(`selected ${value}`)
    setQuantityNum(value)
  }
  let quantityOptions = [...new Array((productDetail?.inStock && productDetail?.inStock > 50) ? 50 : productDetail?.inStock)].map((v: any, i: number) => {
    const stock = i + 1
    let label = `${stock}`
    if (productDetail && productDetail?.inStock > 50 && stock === 50) {
      label = `50(Max)`
    }
    return { value: stock, label: label }
  })

  const router = useRouter()

  // 重新请求数据
  const getProductDetailWithPromotion = async () => {
    if (!productDetail?.productID) return
    if (!getCookie('affiliateid')) return

    const detail = await getProductDetail(productDetail?.productID)

    // 更新带aid的促销价格
    if (productDetail && detail) {
      let updateData = JSON.parse(JSON.stringify(updateProductDetail))

      updateData.price = detail.data.product.price
      updateData.promotionPrice = detail.data.product.promotionPrice
      updateData.normalPrice = detail.data.product.normalPrice
      updateData.promotion = detail.data.product.promotion
      updateData.emailOnlyFinished = detail.data.product.emailOnlyFinished

      // 请求releaseProduct和reviews数据
      const releaseProductData = await productApi.getProductScreen(productDetail?.productID)
      updateData.relatedProducts = releaseProductData.data.relatedProducts

      setUpdateProductDetail(updateData)
    }
  }

  useEffect(() => {
    // Url上可能存在数量参数
    const { quantity }: any = router.query
    if (quantity) setQuantityNum(Number(quantity))

    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''

    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }

    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }

    // 优先于异步请求，将aid存入cookie, 60秒过期（后续会发起请求重新设置）
    if (lastAidValue || lastRecoveraidValue) {
      let currentDomain = window.location.hostname;
      if (currentDomain == 'www.crazysales.com.au') {
        currentDomain = ".crazysales.com.au"
      }
      setCookie('affiliateid', lastAidValue || lastRecoveraidValue, { expires: 30, secure: true, domain: `${currentDomain}`, })
    }
  }, [router.query])

  // cookie有留存aid参数，则更新Email价格
  useEffect(() => {
    setTimeout(() => {
      let affiliateid = getCookie('affiliateid')
      if (affiliateid) getProductDetailWithPromotion()
    }, 400)
  }, [])

  // 设置谷歌GTM dataLayer
  useEffect(() => {
    function handleWindowLoad() {
      if (!productDetail?.breadCrumb || productDetail?.breadCrumb.length <= 0) return

      const ecomm_catname = productDetail?.breadCrumb.map((v: any) => v.name).join(" > ")
      const g_params = {
        "remarketing_params": {
          "ecomm_prodid": productDetail?.productID,
          "ecomm_pagetype": "product",
          "ecomm_totalvalue": productDetail?.price,
          "ecomm_prodname": productDetail?.name,
          "ecomm_catname": ecomm_catname,
          "ecomm_email": ""
        },
        "params": {
          "userId": null,
          "categoryId": null,
          "productId": productDetail?.productID
        }
      }

      setGtmDataLayer(g_params)
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  // 设置schema的priceValidUntil
  const currentDate = new Date();
  currentDate.setFullYear(currentDate.getFullYear() + 1)
  const isoDateString = currentDate.toISOString()
  let priceValidUntil = isoDateString

  /**
   * emarsys tracking数据推送
   */
  // 将外部资源路径抽离出来做配置处理
  interface CartItem {
    productID: string;
    Price: string;
    Quantity: string;
  }
  
  interface CartData {
    cart?: {
      content: CartItem[];
    };
  }
  
  const RECOMMENDER_SUBDOMAIN = 'https://recommender.scarabresearch.com/js/1CBC47CFE1C81625/scarab-v2.js';
  const CDN_SUBDOMAIN = 'http://cdn.scarabresearch.com/js/1CBC47CFE1C81625/scarab-v2.js';
  
  function injectScarabQueueScript(
    userEmail: string | null, 
    scarabQueueCartData: any[], // 请按实际对象结构定义具体的类型
    productId: number | undefined
  ) {
    const script = document.createElement('script');
    script.type = 'text/javascript';

    script.innerHTML = `
      var ScarabQueue = ScarabQueue || [];
      ${userEmail ? `ScarabQueue.push(['setEmail', "${userEmail}"]);` : ''}
      ScarabQueue.push(['cart', ${JSON.stringify(scarabQueueCartData)}]);
      ${productId ? `ScarabQueue.push(["view", "${productId}"]);` : ''}
      ScarabQueue.push(['go']);
    `;
  
    document.body.appendChild(script);
  }
  
  function getCartData(): any[] {
    const cartDataJSON = localStorage.getItem('cartData');
    const cartData: CartData | null = cartDataJSON ? JSON.parse(cartDataJSON) : null;
  
    // 注意返回类型同样需要定义，这里暂时使用 any[]
    return cartData?.cart?.content?.map(item => ({
      item: item.productID,
      price: Number(item.Price),
      quantity: Number(item.Quantity),
    })) ?? [];
  }

  useEffect(() => {
    const subdomain = document.location.protocol === 'https:' ? RECOMMENDER_SUBDOMAIN : CDN_SUBDOMAIN;
    const id = 'scarab-js-api';

    if (document.getElementById(id)) return;

    const js = document.createElement('script');
    js.id = id;
    js.src = subdomain;

    const fs = document.getElementsByTagName('script')[0];
    fs?.parentNode?.insertBefore(js, fs);

    const userEmail = localStorage.getItem('userEmail');
    const scarabQueueCartData = getCartData();

    js.onload = () => injectScarabQueueScript(userEmail, scarabQueueCartData, productDetail?.productID);

    return () => {
      js.remove();
    };
  }, []);


  // 每次进入详情页的商品数据，存一份到localstorage里面
  useEffect(() => {
    let recentProductsList = []

    // localstorage有记录就拿出来
    if (localStorage.getItem('recentProductsList') && localStorage.getItem('recentProductsList') != null) {
      recentProductsList = JSON.parse(String(localStorage.getItem('recentProductsList')))
    }

    // 删除掉当前
    let uniqueProductsList = recentProductsList.filter((product: any) => product.productId != productDetail?.productID);

    uniqueProductsList.unshift({
      productId: productDetail?.productID,
      name: productDetail?.name,
      price: productDetail?.price,
      normalPrice: productDetail?.normalPrice,
      filename: productDetail?.filename,
      url: productDetail?.url
    })

    /**
     * 只保留4个历史查看的商品
     * 检查数组长度，获取前4个元素
     * 存储到localStorage，键名为 'recentProductsList'
     */
    let itemsToStore = uniqueProductsList.length >= 4 ? uniqueProductsList.slice(0, 4) : uniqueProductsList.slice(0)
    localStorage.setItem('recentProductsList', JSON.stringify(itemsToStore));
  }, []);



  /**
   * UVP 的 AB test
   */
  const [abTestVersion, setAbTestVersion] = useState('A');

  useEffect(() => {
    // 先看看cookie，当前是A还是B，cookie没有的话，从abTestCalculate拿
    //  if (getCookie('X-Service-Group-AB')) {
    //    setAbTestVersion(getCookie('X-Service-Group-AB') || 'A')
    //  } else {
    //    abTestCalculate("2024-02-05_ABTest").then((res: unknown) => {
    //      console.log(`Once you enter the page, the traffic starts being counted, and the traffic falls on ${res as string}`)
    //      setAbTestVersion(res as string || 'A');
    //    })
    //  }
  }, []);

  //  获取组合产品
  useEffect(() => {
    getCombineList()
  }, [])

  const [combineInfo, setCombineInfo] = useState({})
  const [combineList, setCombineList] = useState([])

  const getCombineList = async () => {
    try {
      const res = await productApi.combine(productDetail?.productID)
      const { combine, products } = res.data
      setCombineList(products)
      setCombineInfo(combine)
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <>
      <Head>
        <title>{productDetail?.name}</title>
        <meta property="og:type" content="product" />
        <meta property="og:title" content={productDetail?.seo.title} />
        <meta property="og:image" content={productDetail?.filename} />
        <meta property="og:url" content={`${apiDomain}${productDetail?.url}`} />
        <meta property="og:site_name" content="CrazySales" />
        <meta name="keywords" content={productDetail?.seo.keywords} />
        <meta name="description" content={productDetail?.seo.description} />

        <link
          rel="preload"
          as="image"
          href={productDetail?.firstMagnifierImage}
        />
      </Head>

      <DefaultLayout notStickyNavbar={true}>
        {/* schema:Product 添加的商品结构化数据 */}
        <div typeof="schema:Product">
          <div rel="schema:review">
            <div typeof="schema:Review">
              <div rel="schema:reviewRating">
                <div typeof="schema:Rating">
                  <div property="schema:ratingValue" content={String(productDetail?.review?.avgRank)}></div>
                  <div property="schema:bestRating" content="5"></div>
                </div>
              </div>
              <div rel="schema:author">
                <div typeof="schema:Person">
                  <div property="schema:name" content="Customer"></div>
                </div>
              </div>
            </div>
          </div>
          <div rel="schema:aggregateRating">
            <div typeof="schema:AggregateRating">
              <div property="schema:reviewCount" content={String(productDetail?.review?.total || 1)}></div>
              <div property="schema:ratingValue" content={String(productDetail?.review?.avgRank)}></div>
              <div property="schema:bestRating" content="5"></div>
            </div>
          </div>

          <div property="schema:name" content={productDetail?.seo.title}></div>
          <div rel="schema:image" resource={productDetail?.filename}></div>
          <div property="schema:description" content={productDetail?.seo.description || productDetail?.seo.keywords}></div>
          <div property="schema:sku" content={String(productDetail?.productID)}></div>
          <div property="schema:url" content={`${apiDomain}${productDetail?.url}`}></div>

          <div rel="schema:offers">
            <div typeof="schema:Offer">
              <div property="schema:priceCurrency" content="AUD"></div>
              <div property="schema:itemCondition" content="http://schema.org/NewCondition"></div>
              <div property="schema:availability" content="http://schema.org/InStock"></div>
              <div property="schema:price" content={String(productDetail?.price)}></div>
              <div property="schema:priceValidUntil" content={priceValidUntil}></div>
              <div rel="schema:url" resource={`${apiDomain}${productDetail?.url}`}></div>
            </div>
          </div>
        </div>

        {/* schema:BreadcrumbList 添加的商品结构化数据 */}
        <ol vocab="https://schema.org/" typeof="BreadcrumbList" style={{ display: 'none' }}>
          {
            (productDetail?.breadCrumb && productDetail?.breadCrumb.length) &&
            productDetail.breadCrumb.map((item: BreadcrumbItem, index: number) => (
              <li property="itemListElement" typeof="ListItem" key={index}>
                <a property="item" typeof="WebPage"
                  href={`${apiDomain}${item.url}`}>
                  <span property="name">{item.name}</span></a>
                <meta property="position" content={String(index + 1)}></meta>
              </li>
            ))
          }
        </ol>

        {/* schema:WebSite 添加的商品结构化数据 */}
        <div itemScope itemType="https://schema.org/WebSite" style={{ display: 'none' }}>
          <meta itemProp="url" content={`${apiDomain}${productDetail?.url}`} />
          <form itemProp="potentialAction" itemScope itemType="https://schema.org/SearchAction">
            <meta itemProp="target" content={`${apiDomain}/search/{search_term_string}`} />
            <input itemProp="query-input" type="text" name="search_term_string" required />
            <input type="submit" />
          </form>
        </div>

        {/* 详情页真实代码 */}
        <div className={`${styles['page-product-detail']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* People who viewed this item also viewed */}
          {
            !!(updateProductDetail?.relatedProducts && updateProductDetail.relatedProducts.length) &&
            <div className={`${styles['product-also-viewed']} margin-bottom-24`}>
              <div className={styles['title']}>People who viewed this item also viewed</div>
              {/* 轮播 */}
              <SwiperSmall
                slidesPerView={slidesPerView}
                slideChange={onSlideChange}
              >
                {
                  updateProductDetail.relatedProducts.map((item: RelatedProductItem) => (
                    <SwiperSlide key={item.productID}>
                      <div className={styles['product-list']}>
                        <GoodsSmallComponent {...item}></GoodsSmallComponent>
                      </div>
                    </SwiperSlide>
                  ))
                }
              </SwiperSmall>
            </div>
          }

          {/* 面包屑 */}
          {
            !!(productDetail?.breadCrumb && productDetail.breadCrumb.length) &&
            <BreadCrum BreadList={productDetail.breadCrumb}></BreadCrum>
          }

          {/* PromotionBox */}
          {
            (updateProductDetail?.promotion && updateProductDetail.promotion?.promotionType)
            &&
            <PromotionBox
              preSales={updateProductDetail.preSales}
              preSalesDate={updateProductDetail.preSalesDate}
              currentTime={updateProductDetail.currentTime}
              promotion={updateProductDetail.promotion}
              quantityNum={quantityNum}
              emailOnlyFinished={updateProductDetail.emailOnlyFinished}
              crazyDeal={updateProductDetail.crazyDeal}
            ></PromotionBox>
          }

          {/* 商品介绍 */}
          <ProductInfo
            productDetailData={updateProductDetail}
            review={updateProductDetail?.review}
            paymentMethod={updateProductDetail?.paymentMethod}
            quantityOptions={quantityOptions}
            quantityNum={quantityNum}
            displayPurposesOnly={false}
            handleQuantityChange={handleQuantityChange}
          />

          {/* 商品组合 */}
          {
            combineList.length > 0
            &&
            <Combination combineList={combineList} combineInfo={combineInfo} upDateCombine={setCombineList} />
          }

          {/* 商城特色 */}
          {
            // !!(abTestVersion == 'A') &&
            <div className={styles["shop-info-box"]}>
              <ShopInfo hiddenContactus={true}></ShopInfo>
            </div>
          }

          {/* You May Be Interested */}
          <InterestedProducts productId={productDetail?.productID}></InterestedProducts>

          <MidBanner />

          <div className={styles['product-information']} id="product-information">

            <div className={styles['left-box']} id="goods-detail-info-left">
              {/* 商品详情 */}
              <ProductDetail setWarrantyHtml={(html: string) => { setWarrantyHtml(html) }} {...productDetail}></ProductDetail>

              {/* 热搜 */}
              <HotSearch productID={productDetail?.productID}></HotSearch>

              {/* 商品评论 */}
              <ProductReviews productID={productDetail?.productID} review={productDetail?.review}></ProductReviews>

              {/* 支付注意事项 */}
              <PaymentNotice warrantyHtml={warrantyHtml}></PaymentNotice>

              {/* 加购 */}
              <AddPurchase
                productDetailData={productDetail}
                quantityOptions={quantityOptions}
                quantityNum={quantityNum}
                handleQuantityChange={handleQuantityChange}
              />
            </div>
            <div className={styles['right-box']} id="goods-detail-info-right">
              <NewArrivals categoryId={productDetail?.categoryID} />
            </div>
          </div>

          <DetailRecommend productID={productDetail?.productID} />

          <GoogleADSense />
        </div>
      </DefaultLayout>
    </>
  )
}
